import { gql } from '@apollo/client'

export const MUTATION_NEW_PHONE_PLAN = gql`
  mutation mutationNewPhonePlan($input: PhonePlanCaseItemInput!) {
    createPhonePlanCaseItem(input: $input) {
      id
    }
  }
`
